module.exports = __webpack_public_path__ + "img/mall.1e3f04d.svg";